import React from 'react';
import { Quote, Facebook, Instagram } from 'lucide-react';
const testimonials = [{
  quote: "I can't say enough about how happy I was referred to this shop. I am a first time customer and Nicole has been super helpful and accommodating! I am hoping to bring them more business in the future!",
  author: 'Tamara A.'
}, {
  quote: 'No matter what life throws at me teams and tees have been able to make shirts business cards, cups, hats and even see something on for my fiancé dress whites. If you have a problem with them you have a problem with me.',
  author: 'Brianna S.'
}, {
  quote: 'Nicole is such a fun person. She takes GREAT pride in everything she does.',
  author: 'Corina D.'
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white" data-id="element-233">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-236">
            Trusted by Our Local Community
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-237">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-gradient-to-br from-purple-50 to-white rounded-2xl p-8 border border-purple-100 shadow-sm" data-id="element-238">
              <div className="flex items-center justify-center h-10 w-10 bg-purple-100 rounded-full text-purple-600 mb-6" data-id="element-239">
                <Quote className="h-5 w-5" data-id="element-240" />
              </div>
              <p className="text-gray-700 leading-relaxed mb-6 text-lg" data-id="element-241">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-purple-100 pt-4" data-id="element-242">
                <p className="font-semibold text-gray-900" data-id="element-243">
                  {testimonial.author}
                </p>
              </div>
            </div>)}
        </div>

        {/* Trust Indicators & Social */}
        <div className="bg-gray-50 rounded-2xl p-8 border border-gray-100" data-id="element-244">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-245">
            <div className="flex flex-col sm:flex-row items-center gap-6 text-center sm:text-left" data-id="element-246">
              <div className="flex items-center gap-2 text-gray-700" data-id="element-247">
                <div className="h-2 w-2 bg-teal-500 rounded-full" data-id="element-248"></div>
                <span className="font-medium" data-id="element-249">
                  Custom apparel expertise since 2014 · Proudly serving Southern
                  Maryland
                </span>
              </div>
              <div className="flex items-center gap-2 text-gray-700" data-id="element-250">
                <div className="h-2 w-2 bg-purple-500 rounded-full" data-id="element-251"></div>
                <span className="font-medium" data-id="element-252">Local pickup available</span>
              </div>
            </div>

            <div className="flex items-center gap-4" data-id="element-253">
              <span className="text-gray-600 font-medium" data-id="element-254">Follow us:</span>
              <a href="https://www.facebook.com/tntcustomtee/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center h-10 w-10 bg-white rounded-full text-gray-600 hover:text-purple-600 hover:bg-purple-50 transition-colors shadow-sm border border-gray-200" aria-label="Follow us on Facebook" data-id="element-255">
                <Facebook className="h-5 w-5" data-id="element-256" />
              </a>
              <div className="flex items-center justify-center h-10 w-10 bg-white rounded-full text-gray-400 shadow-sm border border-gray-200" data-id="element-257">
                <Instagram className="h-5 w-5" data-id="element-258" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}